export default class AdfInputs {

    constructor() {

        this.inputGroups = document.querySelectorAll('.input-group');
        this.arrInputGroups = Array.from(this.inputGroups);

        this.bindEvents();

    }

    bindEvents() {

        this.arrInputGroups.forEach((el, i) => {

            let input = el.querySelector('input');

            if (!input)
                return;

            if(input.value !== '') {
                el.classList.add("not-empty");
            }

            input.addEventListener('focus', (e) => {
                el.classList.add('focused');
            })

            input.addEventListener('blur', (e) => {
                if(input.value === '') {
                    el.classList.remove("not-empty");
                } else {
                    el.classList.add('not-empty');
                }

                el.classList.remove('focused');
            })
        })

    }
}
